<script type="text/ecmascript-6">
    import DesignerQuestionFrameColourExternal from "../DesignerQuestionFrameColourExternal.vue";

    export default {
        mixins: [
            DesignerQuestionFrameColourExternal
        ],
        computed: {
            filtered_option_list(){
                if (this.option_list === null || !Array.isArray(this.option_list)) {
                    return [];
                }

                return this.option_list.filter((key)=> {
                    return key.value !== null && !!key.value;
                });
            },
            thumbURL(){
                if (this.frameMaterial !== '') {
                    return '/thumb/frame-colour-' + this.frameMaterial + '/';
                } else {
                    return '/thumb/frame-colour/';
                }
            },
        },
        watch: {
            'localTarget': function (val, oldVal) {
                if(this.frameMaterial === 3) {
                    window.emitter.emit('frame-external-colour-updated', val);
                }
            },
        },
        mounted() {
            window.emitter.on('door-external-colour-updated', (new_col) => {
                if(this.frameMaterial === 3){
                    this.localTarget = new_col;
                }
            });
        },
        onUnmounted() {
            window.emitter.off('door-external-colour-updated');
        },
    }
</script>
